export const PLAYER_ACTION = ["-", "FOLD", "CHECK", "CALL", "RAISE", "ALL-IN", "WIN", "LOOSE"];
